<app-page-topbar [title]="'Report Templates'">
    <a *appDesktop class="button" (click)="createNewAssessmentForm()">
        New Report
    </a>
</app-page-topbar>

<app-template-list></app-template-list>
